import React, { createContext, useContext, useState } from "react";
import { BusyIndicator } from "@ui5/webcomponents-react";

// Create the context
const BusyContext = createContext();

// Provide the context
export const BusyProvider = ({ children }) => {
  const [isBusy, setIsBusy] = useState(false);
  const [busyText, setBusyText] = useState("Loading...");

  const showBusy = (text = "Loading...") => {
    setBusyText(text);
    setIsBusy(true);
  };

  const hideBusy = () => {
    setIsBusy(false);
    setBusyText("");
  };

  return (
    <BusyContext.Provider value={{ isBusy, busyText, showBusy, hideBusy }}>
      {children}
      {isBusy && (
        <BusyIndicator
          active
          text={busyText}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        />
      )}
    </BusyContext.Provider>
  );
};

// Hook for consuming the context
export const useBusy = () => useContext(BusyContext);
